export const COLORS = {
    background: '#16213e',
    gridLine: 'rgba(42, 59, 85, 0.32)',
    tileFloor: '#1a1e2a',
    tileWall: '#1a1e2a',
    tileGrass: '#2f7d32',
    tileSand: '#c2a86a',
    tileWater: '#2f6db3',
    tileDirt: '#6c4b33',
    tilePortal: '#3b1d6b', // Purple base for portal tiles
    tilePortalGlow: '#7c3aed', // Brighter purple for glow effect
    tileHover: '#1f2e45',
    player: '#3b82f6',
    playerInner: 'rgba(255, 255, 255, 0.3)',
    queueBg: 'rgba(160, 102, 255, 0.8)',
    queueText: '#ffffff',
    pathLine: 'rgba(160, 102, 255, 0.4)',
    activeTile: 'rgba(255, 255, 255, 0.06)',
    hoverFill: 'rgba(255, 255, 255, 0.08)',
    hoverStroke: 'rgba(255, 255, 255, 0.5)',
    remotePlayer: '#f59e0b',
    enemy: '#ef4444',
    zombie: '#4ade80'
};

export const ENTITY_MOVE_SPEED_TILES_PER_SECOND = 0.06 * 60; // Shared interpolation speed for self + remotes + mobs (~3.6 tiles/sec)
export const ACTIVE_TILE_FADE_RATE_PER_SECOND = 0.08 * 60; // Preserve old fade duration (~0.21s)
export const MAX_FRAME_DELTA_MS = 250;
export const DEFAULT_FRAME_DELTA_MS = 1000 / 60;
export const REMOTE_TELEPORT_SNAP_DISTANCE = 8;
export const ENTITY_FADE_IN_DURATION_MS = 1000;
export const ENTITY_FADE_OUT_DURATION_MS = 1000;
export const ENTITY_FOG_ALPHA = 0.35;

export const POINTER_EVENTS = ['pointermove', 'pointerleave', 'click'] as const;
export type PointerEventName = (typeof POINTER_EVENTS)[number];
